export default __webpack_public_path__ + "media/cuttlefish/logo-6582e02f.svg";